import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const TagsHeader = ({ onCreateTag }) => {
  return (
    <Box 
      sx={{ 
        width: '100%', 
        display: 'flex', 
        padding: '30px 30px 15px 12px',
        zIndex: 11,
        minHeight: '40px',
        alignItems: 'center',
        backgroundColor: '#F7F7F7',
        justifyContent: 'space-between'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Typography variant="subtitle2" sx={{ margin: 0, display: 'flex', alignItems: 'center', fontSize: '20px' }}>
            Tags
          </Typography>
        </Box>
      </Box>

      <Box>
        <Button
          variant="contained"
          onClick={onCreateTag}
          startIcon={
            <svg width="16" height="16" viewBox="0 0 16 16" fill="white">
              <path d="M8 4V12" stroke="#a1a1a1" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"></path>
              <path d="M4 8H12" stroke="#a1a1a1" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"></path>
            </svg>
          }
          sx={{
            backgroundColor: '#D9D9D9',
            color: '#A1A1A1',
            fontWeight: 600,
            fontSize: '0.75rem',
            borderRadius: '20px',
            textTransform: 'none',
            display: 'flex',
            alignItems: 'center',
            padding: '6px 15px',
            border: '1px solid #D9D9D9',
            boxShadow: 'none',  // Remove the shadow
            '&:hover': {
              backgroundColor: '#C9C9C9',
              boxShadow: 'none'  // Remove shadow on hover too
            },
            '& .MuiButton-startIcon': {
              marginRight: '8px',
              '& svg': {
                fontSize: '20px'
              }
            }
          }}
        >
          Create New Tag
        </Button>
      </Box>
    </Box>
  );
};

export default TagsHeader;